// It doesn't support non ASCII characters
export class BufferTextConverter {

    static toText(buffer: ArrayBuffer): string {

        return String.fromCharCode.apply(null, new Uint8Array(buffer));
    }

    static toJson(text: string);
    static toJson(buffer: ArrayBuffer);
    static toJson(obj: string | ArrayBuffer) {
        let actualString;
        if (typeof obj === 'string') {
            actualString = obj;
        } else {
            actualString = BufferTextConverter.toText(obj);
        }

        return JSON.parse(actualString);
    }

    static toBuffer(text: string): ArrayBuffer {

        const buffer = new ArrayBuffer(text.length * 2);
        const bufferView = new Uint16Array(buffer);

        for (let i = 0, strLen = text.length; i < strLen; i++) {
            bufferView[i] = text.charCodeAt(i);
        }

        return buffer;
    }
}
